import styled from 'styled-components';
import { Button } from '@mui/material';
import colors from '@/styles/colors';
import { TextItem } from '@/styles/commonStyles';

export const StyledContainer = styled.section``;

export const StyledRepoWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-areas: '1stCol 2ndCol 3rdCol 4th 5th';
  gap: 10px;
  @media (max-width: 2560px) {
    grid-template-columns: repeat(4, 1fr);
    grid-template-areas: '1stCol 2ndCol 3rdCol 4thcol';
  }
  @media (max-width: 1920px) {
    grid-template-columns: repeat(4, 1fr);
    grid-template-areas: '1stCol 2ndCol 3rdCol 4th';
  }
  @media (max-width: 1680px) {
    grid-template-columns: repeat(3, 1fr);
    grid-template-areas: '1stCol 2ndCol 3rdCol';
  }
  @media (max-width: 1440px) {
    grid-template-columns: repeat(3, 1fr);
    grid-template-areas: '1stCol 2ndCol 3rdCol';
  }
  @media (max-width: 1366px) {
    grid-template-columns: repeat(3, 1fr);
    grid-template-areas: '1stCol 2ndCol 3rdCol';
  }
  @media (max-width: 1280px) {
    grid-template-columns: repeat(3, 1fr);
    grid-template-areas: '1stCol 2ndCol 3rdCol';
  }
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-areas: '1stCol 2ndCol';
  }
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-areas: '1stCol 2ndCol';
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-areas: '1stCol 2ndCol';
  }
  @media (max-width: 576px) {
    grid-template-columns: repeat(1, 1fr);
    grid-template-areas: '1stCol';
  }
`;

export const StyledCardContainer = styled.div.attrs({
  className: 'border-4 border-gray-800',
})`
  display: flex;
  flex-direction: column;
  width: 400px;
  height: 630px;
  border-radius: 10px;
  @media (max-width: 2560px) {
    width: 550px;
  }
  @media (max-width: 1920px) {
    width: 400px;
  }
  @media (max-width: 1680px) {
    width: 450px;
  }
  @media (max-width: 1600px) {
    width: 425px;
  }
  @media (max-width: 1440px) {
    width: 370px;
  }
  @media (max-width: 1366px) {
    width: 350px;
  }
  @media (max-width: 1280px) {
    width: 320px;
  }
  @media (max-width: 1024px) {
    width: 490px;
  }
  @media (max-width: 992px) {
    width: 475px;
  }
  @media (max-width: 962px) {
    width: 375px;
  }
  @media (max-width: 768px) {
    width: 350px;
  }
  @media (max-width: 576px) {
    width: 100%;
    height: 660px;
  }
`;

export const CardImage = styled.img`
  width: 100%;
  height: ${(props) => props?.height || '350px'};
  border-radius: ${(props) => (props?.type === 'list' ? '10px 10px 0 0' : '0')};
  overflow: hidden;
`;
export const CardContent = styled.div.attrs({
  className: 'flex flex-col w-full bg-gray-900 p-2',
})`
  height: ${(props) => props?.cardHeight || 'auto'};
  overflow: ${(props) => (props?.overFlow ? 'hidden' : 'inherit')};
  @media (max-width: 1366px) {
    overflow-y: auto;
  }
  .tooltip-description {
    width: 500px;
    z-index: 9999;
  }
`;

export const RepoLanguagesBlock = styled.div.attrs({
  className: 'flex w-full flex-wrap mt-5',
})`
  align-items: center;
`;

export const RepoLangDots = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: ${(props) => props.bgColor};
  margin-right: 2px;
  @media (max-width: 1024) {
    width: 14px;
    height: 14px;
  }
`;

export const LangAndLabelBlock = styled.div`
  display: flex;
  & > span {
    font-size: 13px;
    color: ${colors.light};
  }
`;

export const RepoLink = styled.a.attrs({
  target: '_blank',
})``;

export const RepoDescription = styled.p`
  width: 100%;
  color: ${colors.light};
`;

// * Repo Footer Styling
export const CardFooter = styled.div.attrs({
  className: 'flex flex-col bg-gray-900 p-2',
})`
  border-radius: 0 0 10px 10px;
`;

export const FooterContent = styled.div.attrs({
  className: 'flex justify-between pt-2 my:auto',
})`
  @media (max-width: 1366px) {
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: center;
  }
`;

export const FooterContentItem = styled.div.attrs({
  className: 'flex justify-center items-center px-1 my-1',
})``;

export const FooterIconBox = styled.div.attrs({
  className: 'rounded-bl-md rounded-tl-md border-r-0',
})`
  border: 1px solid ${colors.lighter};
  padding: 1px 4px;
`;

export const FooterCountBox = styled(TextItem)`
  position: relative;
  float: left;
  padding: 3px 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  vertical-align: middle;
  border: 1px solid ${colors.lighter};
  border-left: 0;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
`;

export const FooterButton = styled(Button).attrs({
  target: '_blank',
  rel: 'noopener noreferrer',
})`
  margin: 8px 0 !important;
  color: ${colors.primary}!important;
  border-color: ${colors.primary}!important;
  width: auto;
  @media (max-width: 1366px) {
    width: 100%;
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`;
